import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { CultureCenterService } from '../cultureCenter.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalComponentService } from '@techmore/global';
import { OAuthError } from 'src/app/share/entity/OauthError';

@Component({
  selector: 'app-member-loading-culture-center',
  templateUrl: './member-loading-culture-center.component.html',
  styleUrls: ['./member-loading-culture-center.component.css']
})
export class MemberLoadingCultureCenterComponent implements OnInit {
  memberInfo: any;
  isBrowser: boolean;

  constructor(
    protected route: ActivatedRoute,
    private service: CultureCenterService,
    @Inject(PLATFORM_ID) protected platformId: object,
    protected globalComponentService: GlobalComponentService,
    protected translateService: TranslateService,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit() {
    if (this.isBrowser) {
      const authCode = this.route.snapshot.queryParams['AuthCode'];
      localStorage.setItem('auth_code', authCode);

      this.service.getMembertoken(authCode).subscribe(
        (data) => {
          window.close();
        },
        (error) => {
          window.opener['loginErrorReason'] = error;

          // this.globalComponentService.openErrorAlert('Error', oauthError.getMessage(), () => {
            window.close();
          // });
        },
        () => {
          // window.opener.location.reload(true);
          // window.open('', '_self', '');
          window.close();
        }
      );
    }
  }
}
